import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import i18n from 'simple-react-i18n'
import AppStore from 'store/AppStore'
import ToastrAction from 'toastr/actions/ToastrAction'
import { CardTable } from '../../../../components/datatable/NewTable'
import Checkbox from '../../../../components/forms/Checkbox'
import Select from '../../../../components/forms/Select'
import Job from '../../../dto/DtoJob'
import ContributorAction from 'referencial/components/contributor/actions/ContributorAction'
import ContributorDto from 'referencial/components/contributor/dto/ContributorDto'
import FractionAction from '../../../../referencial/components/fraction/actions/FractionAction'
import FractionDto from '../../../../referencial/components/fraction/dto/FractionDto'
import QualityAction from '../../../../quality/actions/QualityAction'
import DtoQualification from '../../../../quality/dto/DtoQualification'
import DtoStatus from '../../../../quality/dto/DtoStatus'
import SupportDto from '../../../../referencial/components/support/dto/SupportDto'
import Supportaction from '../../../../referencial/components/support/actions/SupportAction'
import CampaignAction from '../../../../campaign/actions/CampaignAction'
import CampaignDto from '../../../../campaign/dto/CampaignDto'
import { getIntegrationModes, getImportMode } from '../../../../utils/JobUtils'
import { hasValue } from '../../../../utils/NumberUtil'
import { StyledFieldSet } from '../../../../components/StyledElements'
import { exportFile } from '../../../../utils/ExportDataUtil'
import { nbPerPageLabelMedium } from '../../../../referencial/constants/ReferencialConstants'
import IntegrationModeDialog from '../IntegrationModeDialog'
import { Grid } from '@mui/material'
import SimpleDatePicker from '../../../../components/forms/SimpleDatePicker'


class CalculSeee extends Component {
    constructor(props) {
        super(props)
    }

    componentDidMount() {
        if (!this.props.contributors.length) {
            this.props.fetchContributors()
        }
        if (!this.props.qualifications.length) {
            this.props.fetchQualifications()
        }
        if (!this.props.status.length) {
            this.props.fetchStatus()
        }
        if (!this.props.fractions.length) {
            this.props.fetchFractions()
        }
        if (!this.props.supports.length) {
            this.props.fetchSupports()
        }
        if (!this.props.contributors.length) {
            this.props.fetchContributors()
        }
        if (!this.props.qualityCampaigns.length) {
            this.props.fetchQualityCampaigns()
        }
        this.onChangeFilters({})
    }

    onDeleteCode = (s) => {
        if (this.props.isEditMode) {
            const codes = this.props.job.parameters.parameters.filter((code) => code !== s.credentials)
            this.props.addCode(codes)
        }
    }

    addCode = () => {
        if (this.props.isEditMode) {
            const code = this.refs.txtAddCode.value
            const exist = this.props.job.parameters.parameters.find(p => p.toLowerCase() == code.toLowerCase())
            if (!code) {
                AppStore.dispatch(ToastrAction.error(i18n.youMustEnterAtLeastOneBssCode))
            } else if (exist) {
                AppStore.dispatch(ToastrAction.error(i18n.youHaveAlreadyEnteredThisBssCode))
            } else {
                this.props.addCode([code, ...this.props.job.parameters.parameters])
                this.refs.txtAddCode.value = ''
            }
        }
    }

    getStations = () => {
        return this.props.job.parameters.parameters.map((v) => ({ credentials: v }))
    }

    getFilters = () => {
        return this.props.job.parameters?.filters.length && hasValue(this.props.job.parameters?.filters[0]) ? JSON.parse(this.props.job.parameters?.filters[0]) : {}
    }

    getDataTypes = type => {
        const { parameters } = this.props.job
        if (parameters.dataTypes && parameters.dataTypes.length) {
            return parameters.dataTypes.find(d => d.includes(type))
        }
        return ''
    }

    onChangeFilters = (changes) => {
        const parameters = {
            ...this.props.job.parameters,
            filters: [JSON.stringify({
                ...this.getFilters(),
                ...changes,
            })],
        }
        this.props.onChangeJob({ parameters })
    }

    handleChangeDataIntegration = integration => {
        const { parameters } = this.props.job
        const newDataTypes = (() => {
            const data = parameters.dataTypes.filter(d => !d.includes('DATA'))
            if (integration) {
                return [...data, integration]
            }
            return data
        })()
        this.props.onChangeDataTypes(newDataTypes)
    }

    handleChangeStationIntegration = integration => {
        const { parameters } = this.props.job
        const dataTypes = parameters.dataTypes.filter(d => !d.includes('station'))
        if (integration) {
            dataTypes.push('stationIntegration')
        }
        this.props.onChangeDataTypes(dataTypes)
    }

    render() {
        const disabled = { disabled: !this.props.isEditMode }
        const filters = this.getFilters()
        const myData =this.getStations()
        return (
            <>
                <Grid container spacing={4} paddingTop={1}>
                    <Grid size={6}>
                        <Select
                            value={getImportMode(this.getDataTypes('DATA'))}
                            options={getIntegrationModes()}
                            label={ i18n.dataIntegration }
                            labelSpan={ <IntegrationModeDialog /> }
                            onChange={this.handleChangeDataIntegration}
                            data-cy='integrationMode'
                            {...disabled}
                        />
                    </Grid>
                    <Grid size={3}>
                        <Checkbox
                            checked={ !!this.getDataTypes('station') }
                            label={ i18n.integrateStationInfo }
                            onChange={ this.handleChangeStationIntegration }
                            data-cy='integrationStation'
                            { ...disabled }
                        />
                        <Checkbox
                            checked={ filters.noCalculIfExist }
                            label={ i18n.noCalculIfExist }
                            onChange={v => this.onChangeFilters({ noCalculIfExist: v }) }
                            data-cy='noCalculIfExist'
                            { ...disabled }
                        />
                    </Grid>
                    <Grid size={3}>
                        <SimpleDatePicker
                            value={ filters.beginDate }
                            label={ i18n.startDate }
                            onChange={ v => this.onChangeFilters({ beginDate: v }) }
                            data-cy='startDate'
                            { ...disabled }
                        />
                        <SimpleDatePicker
                            value={ filters.endDate }
                            label={ i18n.endDate }
                            onChange={ v => this.onChangeFilters({ endDate: v }) }
                            data-cy='endDate'
                            { ...disabled }
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={2}>
                    <Grid size={6}>
                        <StyledFieldSet>
                            <legend>&nbsp;{ i18n.macroInvertebres }&nbsp;</legend>
                            <Grid container direction='row' spacing={3}>
                                <Checkbox
                                    checked={ filters.ibgdce }
                                    label={ i18n.ibgdce }
                                    onChange={ v => this.onChangeFilters({ ibgdce: v }) }
                                    data-cy='ibgdce'
                                    {...disabled}
                                />
                                <Checkbox
                                    checked={ filters.mgce }
                                    label={ i18n.mgce }
                                    onChange={ v => this.onChangeFilters({ mgce: v }) }
                                    data-cy='mgce'
                                    {...disabled}
                                />
                                <Checkbox
                                    checked={ filters.i2m2 }
                                    label={ i18n.i2m2 }
                                    onChange={ v => this.onChangeFilters({ i2m2: v }) }
                                    data-cy='i2m2'
                                    {...disabled}
                                />
                            </Grid>
                        </StyledFieldSet>
                    </Grid>
                    <Grid size={6}>
                        <StyledFieldSet>
                            <legend>&nbsp;{ i18n.diatomees } et { i18n.macrophyte }&nbsp;</legend>
                            <Grid container direction='row' spacing={3}>
                                <Checkbox
                                    checked={ filters.ibd }
                                    label={ i18n.ibd }
                                    onChange={ v => this.onChangeFilters({ ibd: v }) }
                                    data-cy='ibd'
                                    {...disabled}
                                />
                                <Checkbox
                                    checked={ filters.ibmr }
                                    label={ i18n.ibmr }
                                    onChange={ v => this.onChangeFilters({ ibmr: v }) }
                                    data-cy='ibmr'
                                    disabled
                                />
                            </Grid>
                        </StyledFieldSet>
                    </Grid>
                    <Grid size={4}>
                        <StyledFieldSet>
                            <legend>&nbsp;{ i18n.fish }&nbsp;</legend>
                            <Grid container direction='row' spacing={3}>
                                <Checkbox
                                    checked={ filters.ipr }
                                    label={ i18n.ipr }
                                    onChange={ v => this.onChangeFilters({ ipr: v }) }
                                    data-cy='ipr'
                                    disabled
                                />
                                <Checkbox
                                    checked={ filters.iprPlus }
                                    label={ i18n.iprPlus }
                                    onChange={ v => this.onChangeFilters({ iprPlus: v }) }
                                    data-cy='iprPlus'
                                    disabled
                                />
                                <Checkbox
                                    checked={ filters.iil }
                                    label={ i18n.iil }
                                    onChange={ v => this.onChangeFilters({ iil: v }) }
                                    data-cy='iil'
                                    disabled
                                />
                            </Grid>
                        </StyledFieldSet>
                    </Grid>
                    <Grid size={4}>
                        <StyledFieldSet>
                            <legend>&nbsp;{ i18n.diagnostics }&nbsp;</legend>
                            <Grid container direction='row' spacing={3}>
                                <Checkbox
                                    checked={ filters.ODInvertebres }
                                    label={ i18n.ODInvertebres }
                                    data-cy='ODInvertebres'
                                    onChange={ v => this.onChangeFilters({ ODInvertebres: v }) }
                                    {...disabled}
                                />
                                <Checkbox
                                    checked={ filters.idmTrait }
                                    label={ i18n.idmTrait }
                                    onChange={ v => this.onChangeFilters({ idmTrait: v }) }
                                    data-cy='idmTrait'
                                    disabled
                                />
                                <Checkbox
                                    checked={ filters.ODDiatomées }
                                    label={ i18n.ODDiatomées }
                                    onChange={ v => this.onChangeFilters({ ODDiatomées: v }) }
                                    data-cy='iprPlus'
                                    disabled
                                />
                            </Grid>
                        </StyledFieldSet>
                    </Grid>
                    <Grid size={4}>
                        <StyledFieldSet>
                            <legend>&nbsp;{ i18n.phytoplanctons }&nbsp;</legend>
                            <Grid container direction='row' spacing={3}>
                                <Checkbox
                                    checked={ filters.iplac }
                                    label={ i18n.iplac }
                                    onChange={ v => this.onChangeFilters({ iplac: v }) }
                                    data-cy='iplac'
                                    disabled
                                />
                                <Checkbox
                                    checked={ filters.iphyge }
                                    label={ i18n.iphyge }
                                    onChange={ v => this.onChangeFilters({ iphyge: v }) }
                                    data-cy='iphyge'
                                    disabled
                                />
                            </Grid>
                        </StyledFieldSet>
                    </Grid>
                </Grid>
                <br />
                <div className='row valign-wrapper'>
                    <div className='col s3'>
                        <label>{ i18n.addCredential }</label>
                    </div>
                    <div className='input-field col s9 no-padding'>
                        <div className='col s8'>
                            <input id='txtAddCode'
                                type='text'
                                placeholder={ i18n.surfaceQualitometerExample }
                                ref='txtAddCode'
                                data-cy='code'
                                {...disabled}
                            />
                            <label
                                className='tinyLabel'
                            >{ i18n.code }</label>
                        </div>
                        <a
                            className='waves-effect waves-light btn col offset-s1 s3'
                            onClick={ this.addCode }
                            data-cy='addCode'
                            {...disabled}
                        >
                            { i18n.add }
                        </a>
                    </div>
                </div>
                <Grid container sx={{ alignItems: 'center', marginBottom: '20px' }}>
                    <Grid size={12}>
                        <CardTable
                            rows={ myData }
                            headers={ ['credentials']}
                            title={ i18n.credentials }
                            lineActions={[{
                                icon: 'delete',
                                onClick: (s) => this.onDeleteCode(s),
                                displayed: this.props.isEditMode,
                            }]}
                            rowsPerPageOptions={ nbPerPageLabelMedium }
                            data-cy='Seee_table'
                            actions={[{
                                icon: 'download',
                                onClick: () => exportFile({
                                    data: [{ ...(myData[0]), headers: ['credentials'] }, ...(myData.slice(1, myData.length))],
                                    titleFile: i18n.credentials,
                                }),
                                tooltip: i18n.download,
                            }]}
                            displayHeaders={false}
                        />
                    </Grid>
                </Grid>
            </>
        )
    }
}

CalculSeee.propTypes = {
    job: PropTypes.instanceOf(Job).isRequired,
    addCode: PropTypes.func.isRequired,
    isEditMode: PropTypes.bool,
    onChangeDataTypes: PropTypes.func,
    onChangeFilters: PropTypes.func,
    onChangeJob: PropTypes.func,
    supports: PropTypes.arrayOf(PropTypes.instanceOf(SupportDto)),
    qualifications: PropTypes.arrayOf(PropTypes.instanceOf(DtoQualification)),
    status: PropTypes.arrayOf(PropTypes.instanceOf(DtoStatus)),
    fractions: PropTypes.arrayOf(PropTypes.instanceOf(FractionDto)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    fetchContributor: PropTypes.func,
    fetchSupports: PropTypes.func,
    fetchNetworks: PropTypes.func,
    fetchWatermasses: PropTypes.func,
    fetchQualifications: PropTypes.func,
    fetchStatus: PropTypes.func,
    fetchContributors: PropTypes.func,
    fetchFractions: PropTypes.func,
    qualityCampaigns: PropTypes.arrayOf(PropTypes.instanceOf(CampaignDto)),
    fetchQualityCampaigns: PropTypes.func,
}

const mapStateToProps = store => ({
    networks: store.NetworkReducer.networks,
    contributors: store.ContributorReducer.contributors,
    supports: store.SupportReducer.supports,
    qualifications: store.QualityReducer.qualifications,
    status: store.QualityReducer.status,
    fractions: store.FractionReducer.fractions,
    qualityCampaigns: store.QualityReducer.qualityCampaigns,
})

const mapDispatchToProps = {
    fetchContributors: ContributorAction.fetchContributors,
    fetchStatus: QualityAction.fetchStatus,
    fetchQualifications: QualityAction.fetchQualifications,
    fetchFractions: FractionAction.fetchFractions,
    fetchSupports: Supportaction.fetchSupports,
    fetchQualityCampaigns: CampaignAction.fetchQualityCampaigns,
}

export default connect(mapStateToProps, mapDispatchToProps)(CalculSeee)
